import { PayloadAction } from '@reduxjs/toolkit';
import { EntityTypes } from 'constants/entities';
import { IUpdateState, updateState } from 'core/actions/product/state';
import { createRequest } from 'core/services/admin';
import { INode } from 'types/domain/base';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { flowActions } from './flow';
import { Edge, Node } from 'reactflow';

export interface ICommandState {
  selected: ISelect;
  copyState: CopyState;
  isEditing: boolean;
}

export enum CopyState {
  NOT_COPYING = 0,
  COPY = 1,
  CUT = 2,
}

export interface ICopyItem {
  id: number;
  type: EntityTypes;
  parentEntityType?: EntityTypes;
  parentEntityId?: number;
  offset?: { x: number; y: number };
  node?: INode;
  nodeId?: number;
  courseNodeId?: number;
}

export interface ISelect {
  nodes: Node[];
  edges: Edge[];
}

export interface IPaste {
  offset: INode;
}

export const initialState: ICommandState = {
  selected: { nodes: [], edges: [] },
  copyState: CopyState.NOT_COPYING,
  isEditing: false,
};

const slice = createSlice({
  name: 'commands',
  initialState,
  reducers: {
    select(state, action: PayloadAction<ISelect>) {
      if (state.copyState !== CopyState.NOT_COPYING && !action.payload.nodes.length) return;
      state.selected = action.payload;
      state.isEditing = false;
      state.copyState = CopyState.NOT_COPYING;
    },
    updateCopyState(state, action: PayloadAction<CopyState>) {
      state.copyState = action.payload;
    },
    paste(state, action: PayloadAction<IPaste>) {},
    edit(state, action: PayloadAction<boolean>) {
      state.isEditing = action.payload;
    },
  },
  extraReducers: builder => {
    builder
      // .addCase(updateState, (state, action: PayloadAction<IUpdateState>) => {
      //   if ([EntityTypes.MODULE].includes(action.payload.type)) state.selected = initialState.selected;
      // })
      .addCase(createRequest.fulfilled, mergeCreate)
      .addCase(flowActions.selectModNode, (state, action) => {
        if (action.payload == null) state.isEditing = false;
      })
      .addCase(flowActions.moveView, (state, action) => {
        if (action.payload.manual) state.isEditing = false;
      });
  },
});

export const { actions: commandActions, reducer } = slice;
export const { select } = commandActions;

export default reducer;

export function mergeCreate(state, action) {
  const { id, offlineId } = action.payload;

  if (state.selected[offlineId]) {
    state.selected[id] = state.selected[offlineId];
    delete state.selected[offlineId];
  }
}
